export default __webpack_public_path__ + "static/media/1388.3d94b635.png";